import { render } from "./VtoBody.vue?vue&type=template&id=53e54d12"
import script from "./VtoBody.vue?vue&type=script&lang=js"
export * from "./VtoBody.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__